// extracted by mini-css-extract-plugin
export default {"btnGroup":"AnnouncementModal_btnGroup__TD6PM","btnGroup__groupBtn2":"AnnouncementModal_btnGroup__groupBtn2__qGGki"};